import NewsletterList from './newsletter-list';

export default NewsletterList;
